var _rect, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefreshDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FEE4A2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 36,
    r: 12,
    fill: "#FFBF3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 48C42.6274 48 48 42.6274 48 36C48 32.8044 46.7509 29.9005 44.7143 27.75M36 24C29.3726 24 24 29.3726 24 36C24 39.4318 25.4406 42.5271 27.75 44.7143",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2158 19.9688L38.2496 24.0026L34.2158 28.0364",
    stroke: "#003B6F",
    strokeWidth: 2.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7832 43.9688L33.7494 48.0026L37.7832 52.0364",
    stroke: "#003B6F",
    strokeWidth: 2.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefreshDesktop);
export default __webpack_public_path__ + "static/media/iconRefreshDesktop.0faee739fb1a56898413a941a30d4d67.svg";
export { ForwardRef as ReactComponent };